module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTProCn.137bc231.otf";